module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1257.fa61bc4b.png";